import { ClientWalletActionTypes } from './wallet-actions';

export const initialState = {
  walletList: [],
  dataLoading: true,
  walletChargeCredit: undefined,
  chargeLoading: false,
  currentPage: 1,
  lastPage: 0,
  extendedListLoading: false,
};

function clientWalletReducer(state = initialState, action: any) {
  switch (action.type) {
    case ClientWalletActionTypes.GET_CLIENT_WALLET_LIST: {
      return {
        ...state,
        dataLoading: true,
      };
    }
    case ClientWalletActionTypes.SET_CLIENT_WALLET_LIST:
      return {
        ...state,
        walletList: action?.data?.walletList,
        dataLoading: false,
        lastPage: action?.data?.lastPage,
        currentPage: state.currentPage + 1,
        extendedListLoading: false,
      };

    case ClientWalletActionTypes.SET_CLIENT_WALLET_CHARGE:
      return {
        ...state,
        walletChargeCredit: action?.data?.walletChargeCredit,
        chargeLoading: true,
      };

    case ClientWalletActionTypes.SET_CLIENT_WALLET_INITIAL_CHARGE:
      return {
        ...state,
        chargeLoading: false,
      };

    case ClientWalletActionTypes.GET_CLIENT_EXTENDED_WALLET_LIST:
      return {
        ...state,
        extendedListLoading: true,
      };

    case ClientWalletActionTypes.SET_CLIENT_WALLET_INITIAL:
      return {
        ...initialState,
      };

    default:
      return state;
  }
}

export default clientWalletReducer;
